import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mt-10" }
const _hoisted_2 = { class: "bg-white dark:bg-gray-800 relative shadow-md sm:rounded-lg overflow-hidden" }
const _hoisted_3 = { class: "border-b dark:border-gray-700 mx-4" }
const _hoisted_4 = { class: "flex flex-col-reverse md:flex-row items-center justify-between md:space-x-4 py-3" }
const _hoisted_5 = { class: "w-full lg:w-2/3 flex flex-col space-y-3 md:space-y-0 md:flex-row md:items-center" }
const _hoisted_6 = { class: "w-full md:max-w-sm flex-1 md:mr-4" }
const _hoisted_7 = { class: "w-full md:w-auto flex flex-col md:flex-row mb-3 md:mb-0 items-stretch md:items-center justify-end md:space-x-3 flex-shrink-0" }
const _hoisted_8 = { class: "overflow-x-auto" }
const _hoisted_9 = { class: "w-full text-sm text-left text-gray-500 dark:text-gray-400" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "border-b dark:border-gray-600" }
const _hoisted_13 = {
  class: "px-4 py-4 text-sm text-gray-500",
  colspan: "5"
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = {
  class: "px-4 py-3 font-medium text-gray-900 whitespace-nowrap dark:text-white",
  scope: "row"
}
const _hoisted_16 = { class: "px-4 py-3" }
const _hoisted_17 = { class: "px-4 py-3" }
const _hoisted_18 = { class: "px-4 py-3 whitespace-nowrap" }
const _hoisted_19 = { class: "px-4 py-3 whitespace-nowrap" }
const _hoisted_20 = { class: "flex items-center gap-2" }
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex items-center justify-between space-x-4 pt-3" }, [
          _createElementVNode("div", { class: "flex-1 flex items-center space-x-3" }, [
            _createElementVNode("h5", { class: "dark:text-white font-semibold" }, " Pages ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("label", {
                class: "text-sm font-medium text-gray-900 sr-only dark:text-white",
                for: "page-search"
              }, "Search", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "page-search",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                class: "block w-full p-2 pl-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500",
                placeholder: "Search pages...",
                type: "search"
              }, null, 512), [
                [_vModelText, _ctx.searchQuery]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: "flex items-center justify-center text-white bg-black hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800",
              to: "/administrator/pages/new"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("svg", {
                  class: "h-3.5 w-3.5 mr-2",
                  fill: "none",
                  height: "12",
                  viewBox: "0 0 12 12",
                  width: "12",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M6 0.75V11.25M0.75 6H11.25",
                    stroke: "white",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "1.5"
                  })
                ], -1),
                _createTextVNode(" Add New Page ")
              ])),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("table", _hoisted_9, [
          _cache[7] || (_cache[7] = _createElementVNode("thead", { class: "text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, " Title "),
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, " Slug "),
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, " Status "),
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, " Updated "),
              _createElementVNode("th", {
                class: "px-4 py-3",
                scope: "col"
              }, [
                _createElementVNode("span", { class: "sr-only" }, "Actions")
              ])
            ])
          ], -1)),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, _cache[4] || (_cache[4] = [
                _createElementVNode("tr", { class: "border-b dark:border-gray-600" }, [
                  _createElementVNode("td", {
                    class: "px-4 py-4 text-sm text-gray-500",
                    colspan: "5"
                  }, " Loading pages... ")
                ], -1)
              ])))
            : (_ctx.filteredPages.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                  _createElementVNode("tr", _hoisted_12, [
                    _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.searchQuery ? 'No pages match your search.' : 'No pages yet.'), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPages, (page) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: page._id,
                      class: "border-b dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700"
                    }, [
                      _createElementVNode("th", _hoisted_15, _toDisplayString(page.title), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(page.slug), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(page.status), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.formatDate(page.updatedAt)), 1),
                      _createElementVNode("td", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_router_link, {
                            class: "flex items-center justify-center w-10 h-10 text-gray-700 bg-white border border-gray-300 rounded-lg md:w-10 focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200",
                            to: `/administrator/pages/${page._id}`,
                            "aria-label": "Edit page",
                            title: "Edit"
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createElementVNode("svg", {
                                class: "w-5 h-5",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("path", {
                                  d: "M20,16v4a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V6A2,2,0,0,1,4,4H8",
                                  fill: "none",
                                  stroke: "#000000",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2"
                                }),
                                _createElementVNode("polygon", {
                                  fill: "none",
                                  points: "12.5 15.8 22 6.2 17.8 2 8.3 11.5 8 16 12.5 15.8",
                                  stroke: "#000000",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2"
                                })
                              ], -1)
                            ])),
                            _: 2
                          }, 1032, ["to"]),
                          _createElementVNode("button", {
                            class: "flex items-center justify-center w-10 h-10 text-red-500 bg-white border border-red-400 rounded-lg md:w-10 focus:outline-none hover:bg-gray-100 hover:text-red-600 focus:z-10 focus:ring-4 focus:ring-gray-200",
                            type: "button",
                            "aria-label": "Delete page",
                            title: "Delete",
                            onClick: ($event: any) => (_ctx.deletePage(page._id))
                          }, _cache[6] || (_cache[6] = [
                            _createElementVNode("svg", {
                              class: "w-5 h-5",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                d: "M4 7H20",
                                stroke: "#ff5c5c",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2"
                              }),
                              _createElementVNode("path", {
                                d: "M6 10L7.70141 19.3578C7.87432 20.3088 8.70258 21 9.66915 21H14.3308C15.2974 21 16.1257 20.3087 16.2986 19.3578L18 10",
                                stroke: "#ff5c5c",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2"
                              }),
                              _createElementVNode("path", {
                                d: "M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z",
                                stroke: "#ff5c5c",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2"
                              })
                            ], -1)
                          ]), 8, _hoisted_21)
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
        ])
      ])
    ])
  ]))
}